import moment from 'moment';

const toDateString = (date) => (date ? moment(date).format('YYYY-MM-DD') : undefined);

const upsertTalkingPointPayload = (formData, isPublished = false) => {
  return {
    brandId: formData?.brand?.value,
    isSpecialEvent: formData?.isSpecialEvent,
    hostIds: (formData?.host || []).map((host) => host?.value),
    startDate: toDateString(formData?.displayDateRange?.[0]),
    endDate: toDateString(formData?.displayDateRange?.[1]),
    startTime: formData?.startTime?.value,
    endTime: formData?.endTime?.value,
    title: formData?.title,
    isPublished,
    productHighlights: (formData?.productHighlight || []).map((product) => ({
      sku: product?.value,
      imagePath: product?.isManual ? product?.imageKey : product?.image,
      productName: product?.label,
      note: product?.note || '',
      ...(product?.isManual && { isManual: true }),
    })),
    sections: (formData?.sections || []).map((section) => ({
      title: section?.title,
      content: section?.description,
      orderIndex: section?.orderIndex,
    })),
  };
};

export default upsertTalkingPointPayload;
